import type { RowData } from './types';

export function buildFieldName(record: RowData, day: string): string[] {
  const base = ['openingConfiguration', 'priceConfiguration', 'days', day];
  const { type, guest } = record;

  if (type === 'Daytime' && guest === 'Child') {
    return [...base, 'childDaytimePrice'];
  }

  if (type === 'Daytime' && guest === 'Adult') {
    return [...base, 'daytimePrice'];
  }

  if (type === 'Night stay' && guest === 'Child') {
    return [...base, 'childPrice'];
  }

  if (type === 'Night stay' && guest === 'Adult') {
    return [...base, 'price'];
  }

  if (type === 'Daytime') {
    return [...base, 'daytimePrice'];
  }

  if (guest === 'Child') {
    return [...base, 'childPrice'];
  }

  return [...base, 'price'];
}
